(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/create-game/assets/javascripts/helpers/get-draw-items.js') >= 0) return;  svs.modules.push('/components/marketplace-data/create-game/assets/javascripts/helpers/get-draw-items.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

const _svs$components$marke = svs.components.marketplaceData.createGame.constants,
  BUY_STOP_DIFF = _svs$components$marke.BUY_STOP_DIFF,
  DISABLED_REASONS = _svs$components$marke.DISABLED_REASONS;
const MINIMUM_DIFF_TO_DRAW_PASSED = DISABLED_REASONS.MINIMUM_DIFF_TO_DRAW_PASSED;
const minimumBufferInMs = BUY_STOP_DIFF * 60 * 1000;
const getDrawItems = productDraws => (productDraws || []).map(_ref => {
  let name = _ref.name,
    regCloseTime = _ref.regCloseTime,
    productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    currentNetSale = _ref.currentNetSale,
    drawComment = _ref.drawComment;
  const latestClosingTime = new Date(Date.now() + minimumBufferInMs);
  const isDisabled = new Date(regCloseTime) < latestClosingTime;
  return _objectSpread({
    item: {
      name,
      regCloseTime,
      drawNumber,
      currentNetSale,
      drawComment,
      key: "".concat(productId, "_").concat(drawNumber)
    },
    isDisabled
  }, isDisabled ? {
    disabledReason: MINIMUM_DIFF_TO_DRAW_PASSED
  } : {});
});
setGlobal('svs.components.marketplaceData.createGame.helpers.getDrawItems', getDrawItems);

 })(window);